import { USER_ACCESS_TOKEN_NAME, USER_REFRESH_TOKEN_NAME } from '@shared/config/breakpoints/credentials';

export const setCredentials = ({ accessToken, refreshToken }: { accessToken?: string; refreshToken?: string }) => {
    if (accessToken) {
        window.localStorage.setItem(USER_ACCESS_TOKEN_NAME, accessToken);
    }
    if (refreshToken) {
        window.localStorage.setItem(USER_REFRESH_TOKEN_NAME, refreshToken);
    }
};

export const removeCredentials = () => {
    window.localStorage.removeItem(USER_ACCESS_TOKEN_NAME);
    window.localStorage.removeItem(USER_REFRESH_TOKEN_NAME);
};

export const getCredentials = () => {
    return {
        accessToken: window.localStorage.getItem(USER_ACCESS_TOKEN_NAME),
        refreshToken: window.localStorage.getItem(USER_REFRESH_TOKEN_NAME),
    };
};
